// Storage 入口 —— 根据运行时（Tauri / Web）选择具体适配器。

import type { Storage } from "./types";

export type { BackupBundle, Storage, StoredEvent, StoredRoom, SenderKind } from "./types";

let cached: Promise<Storage> | null = null;

export function getStorage(): Promise<Storage> {
  if (!cached) cached = openStorage();
  return cached;
}

async function openStorage(): Promise<Storage> {
  if (isTauri()) {
    // D5 接 tauri-plugin-sql 时实现 ./sqlite.ts，切到该实现
    // 当前 Tauri 也降级为 IndexedDB（webview 内一样支持）
    const { openIndexedDbStorage } = await import("./indexed-db");
    return await openIndexedDbStorage();
  }
  const { openIndexedDbStorage } = await import("./indexed-db");
  return await openIndexedDbStorage();
}

function isTauri(): boolean {
  if (typeof globalThis.window === "undefined") return false;
  return "__TAURI_INTERNALS__" in globalThis.window;
}
